import React from 'react';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import 'legacy-src/components/assessment/Results/ScoredIcon/index.scss';

const ScoredIconWrapper = ({ children }) => (
  <div className="h-auto mt-0.5 w-16 ml-4 cursor-pointer">{children}</div>
);

const ScoredStatusTooltip = ({ children }) => (
  <div
    id="scored_status_tooltip"
    className="mb-0 leading-relaxed font-normal rounded-xl"
  >
    {children}
  </div>
);

const ScoredIcon = ({
  teacherScored,
  studentScored,
  teacherAndStudentScored,
  hideToolTip,
}) => {
  const studentScoredLabel =
    'Includes free-response questions scored by students';
  const teacherAndStudentScoredLabel = `${studentScoredLabel} and teachers`;
  if (
    teacherScored === 0 &&
    teacherAndStudentScored === 0 &&
    studentScored > 0
  ) {
    return (
      <ScoredIconWrapper>
        {hideToolTip ? (
          <Icon
            name="student_scored"
            size="18px"
            accessibility={{ tabIndex: '0', title: studentScoredLabel }}
          />
        ) : (
          <PopOver
            accessibility={{
              'aria-label': studentScoredLabel,
              'aria-describedby': 'scored_status_tooltip',
              role: 'img',
            }}
            trigger={
              <Icon
                name="student_scored"
                size="18px"
                accessibility={{ ariaHidden: true }}
              />
            }
          >
            <ScoredStatusTooltip>{studentScoredLabel}</ScoredStatusTooltip>
          </PopOver>
        )}
      </ScoredIconWrapper>
    );
  }
  if (teacherAndStudentScored > 0 || (teacherScored > 0 && studentScored > 0)) {
    return (
      <ScoredIconWrapper>
        {hideToolTip ? (
          <Icon
            name="teacher_and_student_scored"
            size="32px"
            accessibility={{
              tabIndex: '0',
              title: teacherAndStudentScoredLabel,
            }}
          />
        ) : (
          <PopOver
            accessibility={{
              'aria-label': teacherAndStudentScoredLabel,
              'aria-describedby': 'scored_status_tooltip',
              role: 'img',
            }}
            trigger={
              <Icon
                name="teacher_and_student_scored"
                size="32px"
                accessibility={{ ariaHidden: true }}
              />
            }
          >
            <ScoredStatusTooltip>
              {teacherAndStudentScoredLabel}
            </ScoredStatusTooltip>
          </PopOver>
        )}
      </ScoredIconWrapper>
    );
  }
  return <span />;
};

export default ScoredIcon;
